import { useNavigate } from "react-router-dom";

/* CSS */
import styles from './SpendingCard.module.css';
import shared from '../../styles/shared.module.css';

/* Utils */
import { formatCurrency } from "../../utils/currencyUtils";

/* Icons */
import info_icon from '../../assets/icons/info_icon.svg';

const SpendingCard = ({ label, value, subtitle, info, tripId }) => {

    const navigate = useNavigate();

    const handleClickTrip = () => {
        if (tripId) {
            navigate(`/trip/${tripId}`);
        }
    };

    const handleClickCost = () => {
        if (tripId) {
            navigate(`/cost/${tripId}`);
        }
    };

    return (
        <div className={styles.spendingCard}>
            <div className={styles.spendingTop}>
                <span className={styles.spendingLabel}>{label}</span>
                <div className={shared.infoIconWrapper} data-tooltip={info}>
                    <img src={info_icon} alt="Info" className={shared.infoIcon} />
                </div>
            </div>

            <div onClick={handleClickCost} className={`${styles.spendingValue} ${tripId ? styles.clickable : ''}`}>{formatCurrency(value)}</div>
            <div onClick={handleClickTrip} className={`${styles.spendingSubtitle} ${tripId ? styles.clickable : ''}`}>{subtitle}</div>
        </div>
    );
};

export default SpendingCard;
